export default __webpack_public_path__ + "static/media/sheep.4ca8f506.svg";